/* =============================================================================
 * LBP Contact · Lantern redesign — page JS
 * Loaded from the `contact-styles` custom-liquid section on
 * /pages/contact-lbp. Vanilla JS, no dependencies.
 *
 * Responsibilities:
 *   1. Lantern click → smooth-scroll to #contact-form, pre-fill the
 *      contact[type] <select> with the matching option (by data-handle),
 *      focus the next empty form field, and update the URL hash + ?type=.
 *   2. ?type= URL parameter on initial load → pre-fill the dropdown and
 *      smooth-scroll to the form, mirroring the homepage's existing
 *      /pages/contact-lbp?type=press deep-link convention.
 *   3. File-upload reveal: clicking the "+ Add a reference image" button
 *      toggles the hidden file input row.
 *   4. The Artist lantern (data-external="true") follows its href to
 *      /pages/artists instead of pre-filling. Handled by simply NOT
 *      preventDefault'ing on those tiles — the <a> follows naturally.
 * ============================================================================= */
(function () {
  'use strict';

  var FORM_ID = 'contact-form';
  var TYPE_SELECT_ID = 'ContactInquiryType';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* --------------------------------------------------------------------------
   * Pre-fill the inquiry-type <select> by handle. Returns true if a matching
   * option was found and selected.
   * ------------------------------------------------------------------------ */
  function preFillType(handle) {
    if (!handle) return false;
    var select = document.getElementById(TYPE_SELECT_ID);
    if (!select) return false;
    var options = select.options;
    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      var optHandle = opt.getAttribute('data-handle') || '';
      if (optHandle && optHandle.toLowerCase() === handle.toLowerCase()) {
        select.selectedIndex = i;
        // Fire change so any listeners (incl. ours) re-evaluate state.
        var evt;
        try {
          evt = new Event('change', { bubbles: true });
        } catch (e) {
          evt = document.createEvent('Event');
          evt.initEvent('change', true, true);
        }
        select.dispatchEvent(evt);
        return true;
      }
    }
    return false;
  }

  /* --------------------------------------------------------------------------
   * Smooth-scroll to the contact form, accounting for sticky header height.
   * ------------------------------------------------------------------------ */
  function scrollToForm() {
    var form = document.getElementById(FORM_ID);
    if (!form) return;
    var headerOffset = 0;
    var header = document.querySelector('.header-section, header.site-header, .shopify-section-header');
    if (header) headerOffset = header.getBoundingClientRect().height + 16;
    var rect = form.getBoundingClientRect();
    var top = rect.top + window.pageYOffset - headerOffset;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  /* --------------------------------------------------------------------------
   * Focus the first empty required form field after a delay (lets the scroll
   * settle before the keyboard pops on mobile).
   * ------------------------------------------------------------------------ */
  function focusFirstEmptyField() {
    var form = document.getElementById(FORM_ID);
    if (!form) return;
    var fields = form.querySelectorAll('input[required], textarea[required]');
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      if (!f.value) {
        try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); }
        return;
      }
    }
  }

  /* --------------------------------------------------------------------------
   * Lantern click handler. Internal lanterns (no data-external) pre-fill +
   * scroll. External lanterns (artist tile, data-external="true") follow
   * their href naturally — we do nothing.
   * ------------------------------------------------------------------------ */
  function onLanternClick(e) {
    var el = e.currentTarget;
    if (el.getAttribute('data-external') === 'true') return; // let the <a> navigate
    var handle = el.getAttribute('data-inquiry');
    if (!handle) return;

    e.preventDefault();
    var matched = preFillType(handle);

    // Update URL hash + ?type= so the deep-link pattern stays consistent.
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('type', handle);
      url.hash = FORM_ID;
      window.history.replaceState({}, '', url.toString());
    } catch (err) { /* IE/old Safari — no-op */ }

    scrollToForm();
    if (matched) {
      // Defer focus until after smooth-scroll completes-ish.
      setTimeout(focusFirstEmptyField, 700);
    }
  }

  function bindLanterns() {
    var lanterns = $$('.inquiry-lantern');
    lanterns.forEach(function (el) {
      el.addEventListener('click', onLanternClick);
    });
  }

  /* --------------------------------------------------------------------------
   * On initial page load, read ?type= from the URL and pre-fill + scroll if
   * a value is present. Mirrors the existing homepage convention
   * (/pages/contact-lbp?type=press).
   * ------------------------------------------------------------------------ */
  function handleInitialUrlType() {
    var params;
    try { params = new URL(window.location.href).searchParams; } catch (e) { return; }
    var handle = params.get('type');
    if (!handle) return;
    // Defer one frame so the form is in the DOM and styled.
    setTimeout(function () {
      var matched = preFillType(handle);
      if (matched) {
        scrollToForm();
        setTimeout(focusFirstEmptyField, 700);
      }
    }, 50);
  }

  /* --------------------------------------------------------------------------
   * File-upload reveal. Clicking the toggle un-hides the file-input row and
   * flips aria-expanded for assistive tech. Clicking again collapses it
   * (and clears the input so we don't accidentally submit a stale file).
   * ------------------------------------------------------------------------ */
  function bindAttachToggle() {
    var btn = document.querySelector('[data-attach-toggle]');
    if (!btn) return;
    var fieldId = btn.getAttribute('aria-controls');
    var field = fieldId ? document.getElementById(fieldId) : null;
    if (!field) return;

    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        field.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
        var input = field.querySelector('input[type="file"]');
        if (input) input.value = '';
      } else {
        field.removeAttribute('hidden');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  }

  /* --------------------------------------------------------------------------
   * Boot
   * ------------------------------------------------------------------------ */
  function init() {
    bindLanterns();
    bindAttachToggle();
    handleInitialUrlType();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
